export default __webpack_public_path__ + "tenant-1-b51ad9261a4b09df2cf9947d2631dd51.bundle.svg";